import axios from "./axiosConfig";

const branchesService = {
  getAll() {
    return axios.get("/branches");
  },

  getByClient(clientId) {
    return axios.get(`/branches/by-client/${clientId}`);
  },

  getById(id) {
    return axios.get(`/branches/${id}`);
  },

  create(data) {
    return axios.post("/branches", data);
  },

  update(id, data) {
    return axios.put(`/branches/${id}`, data);
  },
  
  remove(id) {
    return axios.delete(`/branches/${id}`);
  }
};

export default branchesService;
